import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const vaultRequestsLegacyPlugin = createPlugin({
  id: 'vault-requests',
  routes: {
    root: rootRouteRef,
  },
});

export const VaultRequestsPage = vaultRequestsLegacyPlugin.provide(
  createRoutableExtension({
    name: 'VaultRequestsPage',
    component: () => import('./pages/RequestsPage').then(m => m.RequestsPage),
    mountPoint: rootRouteRef,
  }),
);
